import { User } from "@/interface/User";
import { UserManagementService } from "@/services/user-management/user-management.service";
import { UserService } from "@/services/user/user.service";
import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { map } from "rxjs";
import Swal from "sweetalert2";
import { environment } from "../../../environments/environment";

@Injectable({
  providedIn: "root",
})
export class AuthService {
  user: User;

  constructor(
    private httpClient: HttpClient,
    private router: Router,
    private service: UserService,
    private userManagementService: UserManagementService
  ) {}

  // authenticate(username, password) {
  //   return this.httpClient
  //     .post<any>("http://localhost:8080/authenticate", { username, password })
  //     .pipe(
  //       map(userData => {
  //         localStorage.setItem("username", username);
  //         let tokenStr = "Bearer " + userData.token;
  //         localStorage.setItem("token", tokenStr);
  //         this.service.findbyemail(username).subscribe(
  //           data => {
  //               this.user = data;
  //               const userId = '' + this.user.id
  //               localStorage.setItem("UserId", userId)
  //               localStorage.setItem("fname", this.user.firstName)
  //               localStorage.setItem("lname", this.user.lastName)
  //               localStorage.setItem("roleId", "1")
  //               this.router.navigate(['']);
  //           }
  //         );
  //         return userData;
  //       })
  //     );
  // }

  authenticate(username, password) {
    return this.httpClient
      .post<any>(`${environment.url}/authenticate`, { username, password })
      .pipe(
        map((userData) => {
          localStorage.setItem("username", username);
          let tokenStr = "Bearer " + userData.token;
          localStorage.setItem("token", tokenStr);

          this.userManagementService
            .getMsUserByEmail(username)
            .subscribe((res: any) => {
              console.log(res);
              const role = [];
              const roleName = [];
              res.msUserRoleModelList.forEach((data) => {
                role.push(data.roleId);
                roleName.push(data.roleName);
              });
              localStorage.setItem("UserId", res.id);
              localStorage.setItem("gender", res.gender);
              localStorage.setItem("birthDate", res.birthDate);
              localStorage.setItem("fname", res.firstName);
              localStorage.setItem("lname", res.lastName);
              localStorage.setItem("checkFirstTime", res.firstTime);
              localStorage.setItem("email", res.email);
              localStorage.setItem("username", res.username);
              localStorage.setItem("positionName", res.position);
              localStorage.setItem("positionId", res.positionId);
              localStorage.setItem("checkPDPA", res.checkPDPA);
              localStorage.setItem("role", JSON.stringify(role));
              localStorage.setItem("roleName", JSON.stringify(roleName));
              localStorage.setItem("isTrainee", res.isTrainee);
              if (res.firstTime === "false") {
                this.router.navigate(["reset-password"]);
              } else if (
                res.firstTime === "reset" &&
                res.checkPDPA === "true"
              ) {
                this.router.navigate(["first-time-management"]);
              } else if (
                res.firstTime === "reset" &&
                res.checkPDPA === "false"
              ) {
                this.router.navigate(["pdpa"]);
              } else if (res.checkPDPA === "false") {
                this.router.navigate(["pdpa"]);
              } else {
                if (res.status == "Work") {
                  this.router.navigate(["dashboard"]);
                } else if (res.status == "Resign") {
                  Swal.fire({
                    title: "This username does not exist in the system.",
                    icon: "warning",
                    confirmButtonColor: "#3085d6",
                    confirmButtonText: "OK",
                  });
                }
              }
            });

          return userData;
        })
      );
  }

  isUserLoggedIn() {
    let login = localStorage.getItem("username");
    return !(login === null);
  }

  logOut() {
    localStorage.clear();
    this.router.navigate(["login"]);
  }
}
